import { useAppDispatch, useAppSelector, useCheckout } from '@/lib/hooks'
import {
  setContinueAsGuest as setContinueAsGuestAction,
  setCustomer as setCustomerAction,
} from '@/lib/redux'

export const useSelectedCustomer = () => {
  const dispatch = useAppDispatch()
  const { setQueryParams } = useCheckout()
  const checkout = useAppSelector((state) => state.checkout)

  const setAsGuestCustomer = async () => {
    dispatch(setCustomerAction(null))
    await setQueryParams({
      customerId: null,
    })
  }

  const setCustomer = async (customer: any) => {
    await setQueryParams({ customerId: customer?.id })
    dispatch(setCustomerAction(customer))
  }

  return {
    customer: checkout.customer,
    setAsGuestCustomer,
    setCustomer,
    setContinueAsGuest: (isGuest: boolean) =>
      dispatch(setContinueAsGuestAction(isGuest)),
  }
}
